export default "__VITE_ASSET__4c904a65__"